import { getLanguageFromHostname } from "utilities/vac-language";
import { LOCAL_STORAGE_KEY } from "./constants";
import { Culture, Language } from "./enums";

export const setLangToLocalStorage = (lang: string) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, lang);
};

export const getLanguageFromBrowser = () => {
  const language = navigator.language.split("-")[0];
  return language === 'fr' ? Language.FRENCH : Language.ENGLISH;
}

export const getLangFromLocalStorage = () => {
  const fromHost = getLanguageFromHostname();
  if (fromHost) {
    setLangToLocalStorage(fromHost);
    return fromHost;
  }

  let storageItem = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (storageItem !== Language.ENGLISH && storageItem !== Language.FRENCH) {
    storageItem = getLanguageFromBrowser();
  }

  return storageItem;
};

export const getCurrentCulture  = () => {
  const lang = getLangFromLocalStorage();
  if(lang === Language.FRENCH) {
    return Culture.FRENCH;
  }

  return Culture.ENGLISH;
};

export const obtainTransl = (translResponse: any) => {
  const converted: any = {};
  
  converted[Language.ENGLISH] = translResponse?.attributes || {};

  const localizations = translResponse?.attributes?.localizations?.data || [];
  const frenchLocalization = localizations.find(
    (loc: any) => loc.attributes?.locale === 'fr' || loc.attributes?.locale === 'fr-FR'
  );

  converted[Language.FRENCH] = frenchLocalization?.attributes || {};

  return converted;
};
